module.exports = __webpack_public_path__ + "img/circulationIndex.373e49a7.png";